







































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  CHANGE_APP_USER_DETAILS_MODAL_ERRORS,
  CURRENT_APP_USER_DETAILS,
  OPEN_CHANGE_APP_USER_DETAILS_MODAL,
  SET_CHANGE_APP_USER_DETAILS_MODAL_ERRORS,
  SET_CURRENT_APP_USER_DETAILS,
  SET_OPEN_CHANGE_APP_USER_DETAILS_MODAL,
  UPDATE_USER_CONTACT_DETAILS,
} from '@/types/application-users.types';
import { UserContactDetailsModel } from '@/models/application-user/user-contact-details.model';

interface DataCleansingModel {
  email: string;
  phone: string;
}

@Component({})
export default class ChangeAppUserDetailsModal extends Vue {

  @Inject() public $validator;

  @Action(UPDATE_USER_CONTACT_DETAILS, StoreNamespace.APPLICATION_USER)
  public updateUserContactDetails: (userDetails: UserContactDetailsModel) => void;

  @Mutation(SET_CURRENT_APP_USER_DETAILS, StoreNamespace.APPLICATION_USER)
  public setCurrentAppUserDetails;
  @Mutation(SET_OPEN_CHANGE_APP_USER_DETAILS_MODAL, StoreNamespace.APPLICATION_USER)
  public setOpenChangeAppUserDetailsModal;
  @Mutation(SET_CHANGE_APP_USER_DETAILS_MODAL_ERRORS, StoreNamespace.APPLICATION_USER)
  public setChangeAppUserDetailsModalErrors;

  @Getter(CURRENT_APP_USER_DETAILS, StoreNamespace.APPLICATION_USER)
  public currentAppUserDetails!: UserContactDetailsModel;
  @Getter(OPEN_CHANGE_APP_USER_DETAILS_MODAL, StoreNamespace.APPLICATION_USER)
  public openChangeAppUserDetailsModal!: boolean;
  @Getter(CHANGE_APP_USER_DETAILS_MODAL_ERRORS, StoreNamespace.APPLICATION_USER)
  public changeAppUserDetailsModalErrors!: string[];

  public mounted() {
    this.setChangeAppUserDetailsModalErrors([]);
  }

  public closeDialog(): void {
    this.setOpenChangeAppUserDetailsModal(false);
    this.$emit('onCancel');
  }

  public onChangeAppUserDetails(): void {
    this.$validator.validateAll('changeAppUserDetailsForm')
        .then((result: any) => {
          if (!result) {
            setTimeout(() => {
              const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
              if (firstInput) {
                firstInput.focus();
              }
            });
          } else {
            this.updateUserContactDetails(this.currentAppUserDetails);
          }
        });
  }

  public destroyed() {
    this.setOpenChangeAppUserDetailsModal(false);
    this.setCurrentAppUserDetails(null);
  }

}
